import {defineStore} from 'pinia';
import axios from 'axios';

const apiUrl = process.env.VUE_APP_API_URL;

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: null,
        user: null,
        isAuthenticated: false,
    }),
    actions: {
        setToken(token) {
            this.token = token;
            this.isAuthenticated = !!token;
            localStorage.setItem('token', token);
        },
        clearToken() {
            console.log('19 clearToken');
            this.token = null;
            this.isAuthenticated = false;
            localStorage.removeItem('token');
            localStorage.removeItem('step');
            this.user = null;
            console.log('21 clearToken');
            console.info('Token cleared');

        },
        updateUser(userData) {
            this.user = userData;
        },
        async fetchUser() {
            console.info('Calling fetchUser');
            if (!this.token) {
                this.clearToken();
                console.error('No token available');
                // throw new Error('No token available');
            }
            // try {

            const response = await axios.get(`${apiUrl}/user-verify`, {
                headers: {Authorization: `Bearer ${this.token}`},
            });

            if (response.data.success) {
                this.updateUser(response.data);
                this.isAuthenticated = true;
            } else {
                console.error('Invalid response data');
                this.clearToken();
            }

            // } catch (error) {
            //     this.clearToken();
            //     console.error('Error fetching user:', error);
            //     // throw error;
            // }
        },
    },
    getters: {
        check: (state) => !!state.user,
        // user: (state) => state.user,
    },
});